<p class="quote-card__footer-text">
  <ng-container *ngIf="hasWholeLifePolicy">
    For a detailed pdf of your Whole Life {{ wholeTerm }} Proposal:
    <a
      *ngIf="!displaySupplemental"
      href="javascript:void(0)"
      class="quote-card__view-basic-illustration"
      id="vst-get-basic-illustration"
      (click)="getBasicIllustrationPdf(false)"
    >
      <span>{{ 'View ' + (isJointApp ? 'Whole Life ' : '') + 'Basic Illustration' }}</span>
      <img
        class="quote-card__open-link-icon-right"
        src="/img/components/transition-card/illustration.svg"
        alt="View Basic Illustration"
      />
    </a>
    <a
      *ngIf="displaySupplemental"
      href="javascript:void(0)"
      class="quote-card__view-basic-illustration"
      id="vst-get-basic-illustration"
      (click)="getBasicIllustrationPdf(true)"
    >
      <span>View Supplemental Illustration</span>
      <img
        class="quote-card__open-link-icon-right"
        src="/img/components/transition-card/illustration.svg"
        alt="View Supplemental Illustration"
      />
    </a>
  </ng-container>
</p>
